import React from "react"
import { useDispatch } from "react-redux"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardFooter from "../../shared/RoomCardFooter/RoomCardFooter"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { RoomStatus } from "../../../../enums/RoomStatus.enum"
import { startUpdateSelectedRoom } from "src/pages/home/store/thunks/rooms.thunk"
import { useProfile } from "src/shared/hooks/useProfile"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"

import "./Clean.css"
import { useDate } from "src/shared/hooks/useDate"

const Clean = ({
    roomTypeName,
    roomNumber,
    dateStatusChanged,
    hasIncidences,
    roomId,
}: {
    roomTypeName: string
    roomNumber: string
    dateStatusChanged?: string
    hasIncidences?: boolean
    roomId: string
}) => {
    const { UTCStringToLocalDate } = useDate()
    const dateUTC = UTCStringToLocalDate(dateStatusChanged)
    const [elapsedTime] = useElapsedTime(dateUTC)

    const dispatch = useDispatch()
    const { usuario_id, hotel_id } = useProfile()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    return (
        <Wrapper>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
                iconName="check"
                iconBgColor="var(--green-available)"
            />
            <RoomCardBody verticalAlign="center">
                <span className="room-card--xl-clean__gest-name">{elapsedTime}</span>
                <div className="room-card--xl-clean__description-wrapper">
                    <span className="room-card--xl-clean__gest-number">Tiempo sin ocupar</span>
                </div>
            </RoomCardBody>
            <RoomCardFooter
                text="Pasar a disponible"
                bgColor={"var(--gray-background)"}
                onSliderTriggered={validateIsColabActive(() => {
                    dispatch(
                        startUpdateSelectedRoom({
                            roomId,
                            status: RoomStatus.available,
                            usuarioId: usuario_id,
                            hotelId: hotel_id,
                        })
                    )
                })}
            />
            {InactiveModal}
        </Wrapper>
    )
}

export default Clean
